import { Component, OnInit, Input } from '@angular/core';
import { InflectionCalMethodViewModel, CalculationMethodType } from '../../model/measurement-points.model';

@Component({
  selector: 'inflection-cal-method',
  templateUrl: './inflection-cal-method.component.html',
  styleUrls: ['./inflection-cal-method.component.scss']
})
export class InflectionCalMethodComponent implements OnInit {
  @Input() inflectionCalMethod: InflectionCalMethodViewModel;
  constructor() { }

  ngOnInit() {

    if (this.inflectionCalMethod === undefined){
      this.inflectionCalMethod = new InflectionCalMethodViewModel();

    }
  }









  saveChanges() {


  }
}
